import React from "react"

function Spacer({ h }) {
    return <div style={{ height: h }}></div>
}

export default Spacer
